'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print product change price
 */
    .directive('capProductChangePrice', function () {
        return {
            restrict: 'A',
            scope: {
                price: "=",
                regularPriceOverrideText: "="
            },
            templateUrl: "templates/productchangeprice.html"
        }
    });